// Aggregate per-item tax_details into order-level components keyed by (name, percentage).
// Returns [{name, percentage, amount}, ...] preserving insertion order.
export const aggregateTaxBreakdown = (items = []) => {
  const agg = new Map();
  for (const it of items) {
    for (const td of it?.tax_details || []) {
      const name = td?.name || "Tax";
      const pct = td?.percentage ?? 0;
      const amt = Number(td?.amount || 0);
      const key = `${name}||${pct}`;
      if (agg.has(key)) {
        const existing = agg.get(key);
        existing.amount += amt;
      } else {
        agg.set(key, { name, percentage: pct, amount: amt });
      }
    }
  }
  return Array.from(agg.values()).map((r) => ({
    ...r,
    amount: Math.round(r.amount * 100) / 100,
  }));
};

// Format a tax row label as "SGST 2.5%"
export const taxRowLabel = (row) =>
  row.percentage ? `${row.name} ${row.percentage}%` : row.name;
